/**
 * NumberActionModals — Delete / Block / Edit number action confirmation dialogs.
 * Extracted from ManagePlatform.js (3 inline Dialogs).
 */
import { Trash2, Ban, Edit3, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

export function NumberDeleteModal({ open, onOpenChange, selectedNumber, onCancel, onConfirm, processingNumber }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white max-w-md"
        data-testid="number-delete-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2 text-red-400">
            <Trash2 className="h-6 w-6" />
            حذف الرقم
          </DialogTitle>
          <DialogDescription className="text-[#808080]">
            هل أنت متأكد من حذف الرقم:{' '}
            <span className="text-white" dir="ltr">
              {selectedNumber?.number || selectedNumber?.phone_number}
            </span>
            ؟
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            onClick={onCancel}
            variant="outline"
            className="border-[#2a2a4e] text-white hover:bg-[#2a2a4e]"
            data-testid="number-delete-cancel-btn"
          >
            إلغاء
          </Button>
          <Button
            onClick={onConfirm}
            disabled={processingNumber === selectedNumber?.id}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="number-delete-confirm-btn"
          >
            {processingNumber === selectedNumber?.id ? <Loader2 className="h-4 w-4 animate-spin" /> : 'تأكيد الحذف'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function NumberBlockModal({ open, onOpenChange, selectedNumber, onCancel, onConfirm, processingNumber }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white max-w-md"
        data-testid="number-block-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2 text-orange-400">
            <Ban className="h-6 w-6" />
            حظر الرقم
          </DialogTitle>
          <DialogDescription className="text-[#808080]">
            هل أنت متأكد من حظر الرقم:{' '}
            <span className="text-white" dir="ltr">
              {selectedNumber?.number || selectedNumber?.phone_number}
            </span>
            ؟
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            onClick={onCancel}
            variant="outline"
            className="border-[#2a2a4e] text-white hover:bg-[#2a2a4e]"
            data-testid="number-block-cancel-btn"
          >
            إلغاء
          </Button>
          <Button
            onClick={onConfirm}
            disabled={processingNumber === selectedNumber?.id}
            className="bg-orange-600 hover:bg-orange-700 text-white"
            data-testid="number-block-confirm-btn"
          >
            {processingNumber === selectedNumber?.id ? <Loader2 className="h-4 w-4 animate-spin" /> : 'تأكيد الحظر'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function NumberEditModal({ open, onOpenChange, selectedNumber, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white max-w-md"
        data-testid="number-edit-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2 text-blue-400">
            <Edit3 className="h-6 w-6" />
            تعديل الرقم
          </DialogTitle>
          <DialogDescription className="text-[#808080]">
            تعديل بيانات الرقم:{' '}
            <span className="text-white" dir="ltr">
              {selectedNumber?.number || selectedNumber?.phone_number}
            </span>
          </DialogDescription>
        </DialogHeader>
        <div className="text-center py-8 text-[#808080]">
          <Edit3 className="h-12 w-12 mx-auto mb-3 opacity-30" />
          <p>قريباً - سيتم إضافة نموذج التعديل</p>
        </div>
        <DialogFooter>
          <Button
            onClick={onClose}
            variant="outline"
            className="border-[#2a2a4e] text-white hover:bg-[#2a2a4e]"
            data-testid="number-edit-close-btn"
          >
            إغلاق
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
